import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "relative rounded-md shadow-sm flex-grow" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 sm:text-sm" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "w-4 h-4",
      viewBox: "0 0 20 20",
      fill: "currentColor"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
        "clip-rule": "evenodd"
      })
    ])
  ])
], -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "flex flex-col mt-4 overflow-hidden" }
const _hoisted_6 = { class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_7 = { class: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" }
const _hoisted_8 = { class: "overflow-hidden border-b border-gray-200 shadow sm:rounded-lg" }
const _hoisted_9 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " 名前 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " スタッフ数 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " ユーザー数 ")
  ])
], -1)
const _hoisted_11 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_12 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_15 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }

import moment from "moment";
import Shop from "@/models/Shop";
import { useStore } from "vuex";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShopList',
  setup(__props) {

const PAGE_SIZE = 20;

const store = useStore();
const route = useRoute();
const router = useRouter();

const keyword = computed(() => {
  if (route.query._k) {
    return route.query._k.toString();
  }
  return null;
});

const shops = ref<Shop[]>([]);
const last_evaluated_key = ref<string | null>(null);

watch(route, () => {
  setTimeout(() => {
    if (store.state.is_loading) {
      return;
    }

    refresh();
  }, 500);
});

onMounted(() => {
  refresh();
});

const onKeywordChanged = (e: Event) => {
  const input = e.target as HTMLInputElement;
  console.log(input.value);
  router.replace(`/shops?_k=${input.value}`);
};

// const formatDate = (date: Date, format: string) => {
//   return moment(date).format(format);
// };

const refresh = () => {
  console.log(`try to search (keyword=${keyword.value})`);

  if (store.state.is_loading) {
    return;
  }

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const result = await Shop.search(
        store.state.salon_id,
        keyword.value,
        last_evaluated_key.value,
        PAGE_SIZE
      );
      shops.value = result.shops;
      last_evaluated_key.value = result.last_evaluated_key;
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};


return (_ctx: any,_cache: any) => {
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    page: "request-list",
    title: "Request List"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("input", {
            type: "text",
            name: "price",
            id: "price",
            class: "block w-full py-2 pl-8 pr-3 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-color-2 focus:border-color-2",
            placeholder: "キーワード",
            value: _unref(keyword),
            onChange: onKeywordChanged
          }, null, 40, _hoisted_4)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("table", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("tbody", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shops.value, (shop) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: shop.id,
                      class: _normalizeClass({ 'bg-gray-100': !!shop.deleted_at })
                    }, [
                      _createElementVNode("td", _hoisted_12, [
                        _createTextVNode(_toDisplayString(shop.name), 1),
                        _hoisted_13,
                        _createTextVNode(_toDisplayString(shop.kana), 1)
                      ]),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(shop.staff_count), 1),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(shop.user_count), 1)
                    ], 2))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})